import PasteButton from "@pathwright/ui/src/components/button/PasteButton"
import useClipboard from "@pathwright/web/src/modules/clipboard/useClipboard"
import withPastePathItem from "@pathwright/web/src/modules/path/graphql/withPastePathItem"
import { ConnectStores } from "lib/core/store"
import React from "react"
import "./PathListPaste.css"

const PathListPaste = ({ selection_error, type, paste, isPasting }) => {
  const [error, setError] = React.useState(null)
  const [pasteAttempted, setPasteAttempted] = React.useState(false)
  const clipboard = useClipboard()

  React.useEffect(() => {
    if (pasteAttempted && selection_error) {
      setError(selection_error)
    }

    if (!selection_error && error) {
      setError(null)
    }
  }, [selection_error])

  const clip = clipboard.getClip({ object_type: type })

  if (!clip) return null

  return (
    <div className="PathListPaste">
      <PasteButton
        clip={clip}
        onPaste={async () => {
          setPasteAttempted(true)
          await paste(clip.object_id)
          clipboard.clear({ object_type: type })
        }}
        onCancel={() => clipboard.clear({ object_type: type })}
        tooltipProps={{ placement: "left" }}
      />
    </div>
  )
}

PathListPaste.displayName = "PathListPaste"

const mapStateToProps = function (state, ownProps) {
  const { order, parent } = ownProps
  const { selection, pasting_selection, selection_error } =
    state.pathAdminStore.state

  const isPasting = parent
    ? selection && selection.parent_id === parent && pasting_selection
    : selection && selection.order === order && pasting_selection

  const paste = async (itemId) => {
    const pathId = window.App.getStore("path").get("path").id

    await ownProps.pastePathItem({
      pathId,
      itemId,
      parentId: parent,
      order
    })

    App.getStore("pathAdmin").storeTrigger("path:item:created")
  }

  return _.assign({}, { paste, isPasting, selection_error }, ownProps)
}

const stores = [
  {
    store: "pathAdmin",
    watch: ["selection", "pasting_selection", "selection_error"]
  }
]

export default withPastePathItem(
  ConnectStores(PathListPaste, stores, {}, mapStateToProps)
)
